import React, { useEffect, useState } from 'react';
import { api } from '../../lib/api';

export default function AdminEnrollments() {
  const [rows, setRows] = useState([]);
  useEffect(() => { api.admin.enrollments().then(setRows).catch(() => {}); }, []);

  return (
    <div>
      <div className="mb-6">
        <h1 className="text-2xl md:text-3xl font-extrabold">Enrollments</h1>
        <p className="text-gray-500 text-sm mt-1">{rows.length} total enrollments</p>
      </div>
      <div className="bg-white rounded-2xl border border-gray-200 overflow-hidden">
        <table className="min-w-full text-sm">
          <thead className="bg-gray-50 text-left">
            <tr><th className="px-4 py-3 font-semibold">User</th><th className="px-4 py-3 font-semibold">Course</th><th className="px-4 py-3 font-semibold">Enrolled at</th></tr>
          </thead>
          <tbody className="divide-y divide-gray-100">
            {rows.map(r => (
              <tr key={r.id} className="hover:bg-gray-50">
                <td className="px-4 py-3">
                  <div className="font-semibold">{r.user?.name || '-'}</div>
                  <div className="text-xs text-gray-500">{r.user?.email}</div>
                </td>
                <td className="px-4 py-3">{r.course?.title || '-'}</td>
                <td className="px-4 py-3 text-gray-500">{r.createdAt ? new Date(r.createdAt).toLocaleString() : '-'}</td>
              </tr>
            ))}
            {rows.length === 0 && <tr><td colSpan={3} className="text-center py-12 text-gray-400">No enrollments yet</td></tr>}
          </tbody>
        </table>
      </div>
    </div>
  );
}
